import { useEffect, useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/London");

const AvailableInspectorTile = (props) => {
  const {
    assignedInspectorList,
    selectedSlot,
    setSelectedSlot,
    onShowOtherInspectors,
  } = props;
  const [inspectorExtended, setInspectorExtended] = useState(null);
  //   const [selectedSlot, setSelectedSlot] = useState({});

  useEffect(() => {
    if (assignedInspectorList.length > 0) {
      assignedInspectorList.map((insp) => {
        insp.isExtended = true;
        insp.inspectorSlots = insp.inspectorSlots.map((slot) => ({
          ...slot,
          isDateExtended: false,
        }));
      });
    }
    setInspectorExtended(assignedInspectorList);

    console.log("as", assignedInspectorList, inspectorExtended);
  }, [assignedInspectorList]);
  const allUnavailable = assignedInspectorList.every(
    (inspector) => inspector.availability === false
  );

  const handleExtendCard = (email, bool) => {
    const updatedInspectors = inspectorExtended.map((inspector) =>
      inspector.inspectorEmail === email
        ? { ...inspector, isExtended: bool }
        : inspector
    );
    setInspectorExtended(updatedInspectors);
  };
  const handleExtendDate = (inspectorEmail, targetDate, bool) => {
    setInspectorExtended((prev) =>
      prev.map((inspector) =>
        inspector.inspectorEmail === inspectorEmail
          ? {
              ...inspector,
              inspectorSlots: inspector.inspectorSlots.map((slot) =>
                slot.date === targetDate
                  ? { ...slot, isDateExtended: bool }
                  : slot
              ),
            }
          : inspector
      )
    );
  };

  return (
    <div className="d-flex p-3 gap-3 flex-column">
      {inspectorExtended?.map((inspector) => {
        if (inspector?.isExtended) {
          return (
            <div
              key={inspector?.inspectorEmail}
              className="p-2 inspector-extended"
            >
              <p
                className="inspector-name"
                onClick={() =>
                  handleExtendCard(inspector?.inspectorEmail, false)
                }
              >
                {inspector?.inspectorName}
              </p>
              <p className="inspector-availability pb-2">
                {inspector.availability ? "Available" : "Unavailable"}
              </p>
              {inspector?.inspectorSlots?.map((day) => {
                const displayDate = dayjs(day?.date).tz("Europe/London").format("ddd, MMM D");
                if (!day?.isDateExtended) {
                  return (
                    <div
                      className="schedule-date-box mb-1"
                      key={day?.date}
                      onClick={() => {
                        if (day?.slots?.length > 0) {
                          handleExtendDate(
                            inspector?.inspectorEmail,
                            day?.date,
                            true
                          );
                        }
                      }}
                    >
                      <span className="inspector-date">
                        {displayDate} - {day?.slots?.length} Slots
                      </span>
                    </div>
                  );
                } else {
                  return (
                    <div className="schedule-date-box-extended" key={day?.date}>
                      <span
                        className="inspector-date"
                        onClick={() =>
                          handleExtendDate(
                            inspector?.inspectorEmail,
                            day?.date,
                            false
                          )
                        }
                      >
                        Slots for {displayDate}
                      </span>
                      <RadioGroup
                        className="mt-2"
                        key={day?.date}
                        row
                        aria-labelledby={`slots for-${inspector?.inspectorEmail}`}
                        name={`slots-${inspector?.inspectorEmail}`}
                        value={
                          selectedSlot[inspector?.inspectorEmail]?.slotId || ""
                        }
                        onChange={(e) => {
                          const slotId = e.target.value;

                          const slotData = inspector?.inspectorSlots
                            .flatMap((day) =>
                              day?.slots?.map((slot) => ({
                                ...slot,
                                date: day.date,
                                inspectorEmail: inspector?.inspectorEmail,
                                inspectorName: inspector?.inspectorName,
                                slotId: `${inspector?.inspectorEmail}-${day?.date}-${slot?.startTime}`,
                              }))
                            )
                            .find((s) => s.slotId === slotId);

                          setSelectedSlot((prev) => ({
                            ...prev,
                            [inspector.inspectorEmail]: slotData,
                          }));
                        }}
                      >
                        {day?.slots?.map((slot) => {
                          const slotId = `${inspector.inspectorEmail}-${day.date}-${slot.startTime}`;
                          const displayDate = dayjs(day.date).tz("Europe/London").format(
                            "ddd, MMM D"
                          );
                          const displayTime = dayjs(slot.startTime).tz("Europe/London").format(
                            "h:mm A"
                          );
                          return (
                            <FormControlLabel
                              className="radio-box mb-2 mr-3 py-1"
                              key={slotId}
                              value={slotId}
                              control={<Radio size="small" />}
                              label={
                                <div className="d-flex flex-column align-items-start">
                                  <span className="display-date">
                                    {displayDate}
                                  </span>
                                  <span className="display-time">
                                    {displayTime}
                                  </span>
                                </div>
                              }
                            />
                          );
                        })}
                      </RadioGroup>
                    </div>
                  );
                }
              })}
            </div>
          );
        } else {
          return (
            <div
              key={inspector?.inspectorEmail}
              className={
                inspector.availability
                  ? "px-3 py-2 inspector_available"
                  : "px-3 py-2 inspector_unavailable"
              }
              onClick={() => {
                if (inspector?.availability) {
                  handleExtendCard(inspector?.inspectorEmail, true);
                }
              }}
            >
              <p className="inspector-name">{inspector?.inspectorName}</p>
              <p className="inspector-availability">
                {inspector.availability ? "Available" : "Unavailable"}
              </p>
            </div>
          );
        }
      })}
      {allUnavailable && (
        <span className="otherInspectors" onClick={onShowOtherInspectors}>
          Show other available inspectors
        </span>
      )}
    </div>
  );
};

export default AvailableInspectorTile;
